var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147 318c67 0 143 2 211-1l1-1v-1c0-1-7-12-21-35-1-2-3-5-4-8-1 0-2 1-4 1H76c-1 0-2-1-3-1-2 3-3 6-5 8-14 23-21 34-21 35l1 1v1c1 1 12 1 35 1h64zm180-59c-3-8-6-16-9-26-5-19-8-41-8-67 0-13-3-26-8-38-6-12-13-23-23-32s-22-17-35-21c-8-4-16-6-25-7h-1c-5-1-10-1-15-1s-10 0-14 1h-1c-9 1-18 3-26 7-12 4-24 12-34 21s-18 20-23 32-8 25-8 38c0 26-4 48-9 67-2 10-6 18-9 26h248zM181 56V23c0-7 2-12 6-16s10-7 16-7 12 3 16 7 7 10 7 16v33c8 1 16 3 23 6 14 6 28 14 39 24 11 11 20 23 26 37 6 13 9 28 9 43 0 25 3 46 8 63 5 18 12 33 19 44 15 25 23 38 22 43 0 3 0 5-1 7h-1c-1 2-2 3-4 5-3 2-7 2-15 3h-85v12c0 18-7 33-18 45-12 11-27 18-45 18-17 0-33-7-45-18-11-12-18-27-18-45v-12H83c-26 0-38 0-42-3h-1c-2-2-3-3-4-5s-2-4-2-7c0-5 7-18 23-43 7-11 14-26 18-44 5-17 8-38 8-63 0-15 4-30 10-43 6-14 14-26 26-37 11-10 24-18 38-24 8-3 16-5 24-6zm31-2V23c0-3 0-5-2-7s-4-3-7-3c-2 0-5 1-6 3-2 2-3 4-3 7v31h18zm-59 277v12c0 14 6 26 15 35s21 15 35 15 26-6 35-15 15-21 15-35v-12H153z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/Notifications.3b0fda6c80100ec83b6b12c018c9df27.svg";
export { ForwardRef as ReactComponent };